// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExclamationOutlinedSvg from "@fishx/icons-svg/es/asn/FileExclamationOutlined";
import FishxIcon from '../components/FishxIcon';

var FileExclamationOutlined = function FileExclamationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExclamationOutlinedSvg
  }));
};

FileExclamationOutlined.displayName = 'FileExclamationOutlined';
export default React.forwardRef(FileExclamationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExclamationOutlined.js
// module id = 2695
// module chunks = 0